import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { guestAccessAttempt } from "../../features/guest/guestSlice";
import { Wrapper, MyRoadmapWrapper, Header, CurrentLessonButton, TitleWrapper, Title, MainText, CardsText, CardsList } from "./MyProgressStyle"
import Roadmap from "./01_roadmap/Roadmap"
import Cards from "./02_cards/Cards"
import ProgressChart from "./04_progress_chart/ProgressChart"
import { fetchProgressChart } from "../../features/progressChart/progressChartSlice";
import { myprogress } from "../../i18n/04_myprogress";

const MyProgress = () => {

  const lang = useSelector(state => state.lang.lang)

  const t = myprogress[lang]

  const [isGuest, setIsGuest] = useState(false)

  const dispatch = useDispatch()

  // const { loading, error } = useSelector((state) => state.studentLessons);

  const role = useSelector((s) => s.auth?.user?.role);
  const selectedStudentId = useSelector((s) => s.teacher?.selectedStudentId);

  const isTeacher = role === "TEACHER";

  const guestClick = () => {
    if (isGuest) {
      dispatch(guestAccessAttempt());
      return;
    }
  }

  useEffect(() => {
    setIsGuest(!role);
  }, [role]);

  useEffect(() => {
    // Student: load own chart
    // Teacher/Admin: load selected student's chart (slice will error if none selected)
    dispatch(fetchProgressChart());
  }, [dispatch, role, selectedStudentId]);

  if (isTeacher && !selectedStudentId) {
    return (
      <Wrapper>
        <Header>{t.header}</Header>
        <MainText>
          Please go to the Teacher Portal and select a student first.
        </MainText>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Header>
        {t.header}
      </Header>
      <TitleWrapper>
        <Title>{t.mapTitle}</Title>
        <CurrentLessonButton to="/myprogress/lesson"
          onClick={guestClick}
        >{t.currentLessonButton}</CurrentLessonButton>
      </TitleWrapper>
      <MainText>
        {t.mapText}
      </MainText>

      {/* {loading && <p>Loading your lessons...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>} */}

      <Roadmap
        guestClick={guestClick}
      />
      <div>

        <CardsText>
          {t.cardsText}
        </CardsText>
      </div>
      <Cards
        guestClick={guestClick}
      />
      <ProgressChart />
    </Wrapper>
  )
}

export default MyProgress